/**
 * What the split screen does with a card share's checkout response.
 * A Paymob intention comes back with clientSecret + publicKey for the
 * embedded Pixel form; its returnUrl is where Paymob sends the guest AFTER
 * paying (3DS), never a place to go now.
 */
export interface SplitIntentLike {
  status?: string | null;
  clientSecret?: string | null;
  publicKey?: string | null;
  returnUrl?: string | null;
  metadata?: Record<string, unknown> | null;
  amount?: number;
  currency?: string;
}

export type SplitCheckoutAction =
  | { kind: "pixel" }
  | { kind: "redirect"; url: string }
  | { kind: "bill" };

export function splitCheckoutAction(intent: SplitIntentLike): SplitCheckoutAction {
  if (intent.clientSecret && intent.publicKey) return { kind: "pixel" };
  const redirect = intent.metadata?.["redirectUrl"];
  if (intent.status === "requires_action" && typeof redirect === "string" && redirect.startsWith("http")) {
    return { kind: "redirect", url: redirect };
  }
  return { kind: "bill" };
}

/** This storefront's bill for the order (same origin + slug), marked as a
 *  payment return so the bill re-reads the split state. */
export function splitReturnUrl(
  origin: string,
  pathname: string,
  orderId: string,
  splitId: string,
): string {
  const base = pathname.replace(/\/orders\/[^/]+\/split.*$/, "");
  const q = new URLSearchParams({ paymentReturn: "1", splitId });
  return `${origin}${base}/dine-in-order/${encodeURIComponent(orderId)}?${q}`;
}
